import { render } from "./iot-hub-form.vue?vue&type=template&id=60aa78f2"
import script from "./iot-hub-form.vue?vue&type=script&lang=js"
export * from "./iot-hub-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__